'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _AbstractReactComponent = require('./../AbstractReactComponent');

var _AbstractReactComponent2 = _interopRequireDefault(_AbstractReactComponent);

var _reactstrap = require('reactstrap');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Třída pro zobrazení globálních validačních chyb na formuláři.
 *
 * Použití:
 * const {error} = this.props;
 * {error && <ValidationErrors error={error}/>}
 */
var ValidationErrors = function (_AbstractReactCompone) {
    (0, _inherits3.default)(ValidationErrors, _AbstractReactCompone);

    function ValidationErrors() {
        (0, _classCallCheck3.default)(this, ValidationErrors);
        return (0, _possibleConstructorReturn3.default)(this, (ValidationErrors.__proto__ || (0, _getPrototypeOf2.default)(ValidationErrors)).apply(this, arguments));
    }

    (0, _createClass3.default)(ValidationErrors, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                error = _props.error,
                className = _props.className;


            if (Array.isArray(error)) {
                var rows = error.map(function (err) {
                    return _react2.default.createElement(
                        'div',
                        null,
                        err
                    );
                });
                return _react2.default.createElement(
                    _reactstrap.Alert,
                    { color: 'danger', className: className },
                    rows
                );
            } else {
                return _react2.default.createElement(
                    _reactstrap.Alert,
                    { color: 'danger', className: className },
                    error
                );
            }
        }
    }]);
    return ValidationErrors;
}(_AbstractReactComponent2.default);

ValidationErrors.PropTypes = {
    error: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.array])
};
exports.default = ValidationErrors;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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